<template>
  <!-- 侧边栏 -->
  <el-scrollbar class="side flex-shrink-0" tag="ul" v-loading="tabsLoading">
    <li
      v-if="tabsSearchList.length > 0"
      :class="{ active: isActive === 0 }"
      class="py-2 mx-4"
      style="border-bottom: none"
      @click="selectSide(0)"
      :key="0"
    >
      <div class="title" v-if="tabsSearchList[0].interviewerName">
        {{ tabsSearchList[0].interviewerName }}（{{ getThousandNumber(tabsSearchList[0].pendingQcNum + '') }}）
      </div>
    </li>
    <div class="search-input">
      <el-input
        size="small"
        placeholder="调查员姓名/手机号"
        suffix-icon="el-icon-search"
        :clearable="true"
        @change="searchChange($event)"
        v-model="key"
      ></el-input>
    </div>
    <template v-for="(item, idx) in tabsSearchList">
      <li
        :class="{ active: isActive === idx }"
        v-if="idx != 0"
        @click="selectSide(idx)"
        :key="idx"
        class="mx-4 pt-4 pb-3 text-left text-theme-black-850"
      >
        <div class="w-full break-all">
          <span class="title" v-if="item.interviewerName">{{ item.interviewerName }}</span>
          <span class="title" v-if="item.interviewerName && item.interviewerTelephone">-</span>
          <span v-if="item.interviewerTelephone" :class="item.interviewerName ? 'subtitle' : 'title'">
            {{ item.interviewerTelephone }}
          </span>
        </div>
        <div class="num text-theme-black-450">（{{ getThousandNumber(item.pendingQcNum + '') }}）</div>
      </li>
    </template>
  </el-scrollbar>
</template>

<script>
import { getThousandNumber, deepClone } from '@/assets/js/utils.js'
export default {
  name: 'InterviewSearchList',
  props: {
    isActive: {
      type: Number,
      default: 0
    },
    tabsSearchList: {
      type: Array,
      default: () => []
    },
    tabsLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      key: ''
    }
  },
  methods: {
    getThousandNumber,
    selectSide(idx) {
      this.$emit('select-side', idx)
    },
    searchChange(e) {
      this.$emit('search-change', e)
    }
  }
}
</script>
<style lang="scss" scoped>
.side {
  width: 203px;
  height: 100%;
  text-align: left;
  box-sizing: border-box;
  @apply bg-white;
  ::v-deep .el-loading-mask {
    z-index: 0 !important;
  }
  li {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    .title {
      font-size: 14px;
      line-height: 22px;
    }
    .subtitle {
      font-size: 12px;
      line-height: 16px;
      width: 148px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .num {
      @apply text-small leading-18;
    }
    &:hover {
      @apply text-theme;
      .num {
        @apply text-theme;
      }
    }
    &:not(:hover) {
      .title,
      .subtitle {
        @apply text-333;
      }
      .num {
        @apply text-666;
      }
      &.active {
        .title,
        .subtitle {
          @apply text-theme;
        }
        .num {
          @apply text-theme;
        }
      }
    }
  }
  .search-input {
    @apply px-4;
    height: 40px; // todo
    ::v-deep .el-input--small.el-input--prefix .el-input__inner {
      padding-left: 24px !important;
    }
    ::v-deep .el-input__suffix-inner {
      @apply flex;
    }
    ::v-deep .el-input__inner {
      font-size: 12px;
    }
    ::v-deep .el-input__icon {
      width: 13px !important;
    }
  }
}
.el-scrollbar {
  @apply shadow-none border-r border-border-gray border-solid;
}
</style>
